import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91美剧网',
    url: 'https://www.91meiju.com/',
    description: '91美剧网是专注美剧资源的在线追剧平台，提供最新热门美剧、经典美剧全集免费在线观看。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@91meiju.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '91美剧网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91美剧网是一个专注美剧资源的在线追剧信息平台，提供最新热门美剧和经典美剧全集的详细介绍、海报展示和分类浏览。',
        },
      },
      {
        '@type': 'Question',
        name: '91美剧网上的美剧资源更新快吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91美剧网第一时间更新最新美剧剧集信息，确保用户可以及时了解最新剧集的更新动态和详细信息。',
        },
      },
      {
        '@type': 'Question',
        name: '91美剧网有哪些美剧分类？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91美剧网涵盖动作冒险、悬疑惊悚、科幻奇幻、剧情爱情、犯罪刑侦、喜剧和恐怖等多种美剧类型，满足不同观众的追剧需求。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>

          <section className="w-full max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于91美剧网
            </h1>
            <p className="text-sm text-foreground-500 leading-relaxed mb-12">
              91美剧网是一个专为美剧爱好者打造的在线追剧信息平台，致力于为用户提供最新、最全的美剧资讯和详细剧集信息。
            </p>

            <section className="mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-5">品牌介绍</h2>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 space-y-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  91美剧网成立于2018年，是国内最早一批专注于美剧资源整合的在线平台之一。我们始终坚持以用户需求为导向，不断优化平台体验，为美剧爱好者提供便捷、高效、全面的追剧信息服务。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  平台收录了超过1000部美剧的详细信息，涵盖动作、悬疑、科幻、爱情、犯罪、喜剧、恐怖等七大核心分类。无论是《权力的游戏》这样的史诗巨作，还是《绝命毒师》这样的口碑神剧，抑或是《白莲花度假村》这样的精品限定剧，您都能在91美剧网找到详尽的剧集信息。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们的编辑团队由资深美剧迷组成，每天关注全球美剧动态，第一时间更新最新剧集信息，确保平台内容的时效性和准确性。高清海报、详细分集列表、专业剧评，让您的追剧体验更加完整。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  91美剧网以"让追剧成为一种享受"为使命，持续优化用户体验。我们相信，好的美剧值得被更多人发现和欣赏，而91美剧网就是连接优质美剧与热爱者的桥梁。
                </p>
              </div>
            </section>

            <section className="mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-5">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    content: '一直在91美剧网追剧更新，分类很全，更新速度也很快，推荐给所有美剧迷！',
                    author: '资深美剧迷 - 张先生',
                    rating: 5,
                  },
                  {
                    content: '找老剧和新剧都很方便，每部剧的详细介绍和分集列表都整理得很清楚，体验很好。',
                    author: '追剧达人 - 李女士',
                    rating: 5,
                  },
                  {
                    content: '作为美剧爱好者，91美剧网是我每天必逛的网站，推荐功能和分类浏览特别好用。',
                    author: '影视从业者 - 王先生',
                    rating: 5,
                  },
                ].map((review) => (
                  <div key={review.author} className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm" />
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      &ldquo;{review.content}&rdquo;
                    </p>
                    <p className="text-xs text-foreground-400 font-medium">{review.author}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-5">常见问题</h2>
              <div className="space-y-3">
                {[
                  { q: '91美剧网是什么？', a: '91美剧网是一个专注美剧资源的在线追剧信息平台，提供最新热门美剧和经典美剧全集的详细介绍、海报展示和分类浏览服务。' },
                  { q: '91美剧网上的美剧资源更新快吗？', a: '我们的编辑团队实时关注美剧动态，第一时间更新最新剧集信息，确保您可以及时了解喜欢的剧集更新情况。' },
                  { q: '91美剧网有哪些美剧分类？', a: '平台涵盖动作冒险、悬疑惊悚、科幻奇幻、剧情爱情、犯罪刑侦、喜剧和恐怖等七大类型，覆盖几乎所有主流美剧类型。' },
                  { q: '如何找到我想看的美剧？', a: '您可以通过首页热门推荐、分类浏览页面按类型筛选，或直接使用搜索功能查找您感兴趣的美剧。' },
                ].map((faq, i) => (
                  <details key={i} className="bg-background-50 rounded-lg border border-background-200/70 group">
                    <summary className="p-5 cursor-pointer list-none flex items-center justify-between text-sm font-medium text-foreground-950 hover:text-primary-500 transition-colors">
                      {faq.q}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:hidden" />
                      <i className="ri-arrow-up-s-line text-foreground-400 hidden group-open:block" />
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-5">联系我们</h2>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                      <i className="ri-mail-line text-lg" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">电子邮箱</p>
                      <p className="text-sm text-foreground-500">contact@91meiju.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-customer-service-line text-lg" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">客服支持</p>
                      <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">公司地址</p>
                      <p className="text-sm text-foreground-500">中国·北京</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                      <i className="ri-global-line text-lg" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-950 mb-1">官方网站</p>
                      <p className="text-sm text-foreground-500">www.91meiju.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}